import React from 'react'

export default function SellerChangePassword() {
  return (
    <div>
      
    </div>
  )
}
